import React from 'react';

const ArticleDetail = ({ item, allItems, categories = [], onBack, onNavigateTo }) => {
  // Get 3 other items for recommendations
  const related = allItems
    .filter(i => i.id !== item.id)
    .slice(0, 3);

  const categoryName = item.type === 'page' ? 'Official Page' : (
    categories?.find(c => c.id === item.categories?.[0])?.name || 'Editorial'
  );

  return (
    <main className="pt-32 pb-24 animate-in fade-in slide-in-from-bottom-8 duration-700">
      <header className="max-w-4xl mx-auto px-6 mb-20 text-center text-on-surface">
        <button 
          onClick={onBack}
          className="mb-8 flex items-center justify-center gap-2 group text-zinc-400 hover:text-primary transition-colors uppercase font-label text-xs font-bold tracking-widest"
        >
          <span className="material-symbols-outlined text-lg transition-transform group-hover:-translate-x-1">arrow_back</span>
          Back to All Insights
        </button>
        
        <div className="mb-6">
          <span className="bg-surface-container-low text-primary font-label text-[0.65rem] font-bold uppercase tracking-[0.2em] px-3 py-1 rounded-full">
             {categoryName} • GreenMark Journal
          </span>
        </div>
        <h1 
          className="font-headline text-5xl md:text-7xl font-bold tracking-tight text-on-surface leading-[1.05] mb-8 italic"
          dangerouslySetInnerHTML={{ __html: item.title.rendered }}
        />
        <div className="flex items-center justify-center gap-4 text-on-surface-variant font-label text-sm tracking-wide">
          <time>{new Date(item.date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</time>
          <span className="opacity-30">•</span>
          <span className="flex items-center gap-1"><span className="material-symbols-outlined text-sm">language</span> GreenMark Cloud</span>
        </div>
      </header>

      <article className="max-w-3xl mx-auto px-6 mb-32 text-on-surface">
        <div 
          className="wp-content"
          dangerouslySetInnerHTML={{ __html: item.content.rendered }}
        />
      </article>

      {/* Recommended Readings Section */}
      <section className="max-w-6xl mx-auto px-8 py-24 border-t border-zinc-100">
        <div className="flex items-center justify-between mb-16 px-4">
          <h2 className="font-headline text-4xl font-bold italic tracking-tight">Recommended Readings</h2>
          <button 
            onClick={onBack}
            className="text-primary font-label text-xs font-bold uppercase tracking-[0.2em] flex items-center gap-2 hover:opacity-70 transition-opacity"
          >
            See All Insights
            <span className="material-symbols-outlined text-sm">arrow_forward</span>
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {related.map((rel) => (
            <div 
              key={rel.id} 
              className="group cursor-pointer space-y-6"
              onClick={() => onNavigateTo(rel)}
            >
              <div className="aspect-[4/3] rounded-lg overflow-hidden bg-surface-container shadow-sm group-hover:shadow-xl transition-all duration-500">
                <img 
                  src={rel.smartThumbnail} 
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" 
                  alt="Related" 
                />
              </div>
              <div className="space-y-2 px-1">
                <span className="text-primary font-label text-[10px] font-bold uppercase tracking-[0.2em]">
                  {rel.type}
                </span>
                <h3 
                  className="font-headline text-2xl font-bold leading-tight group-hover:text-primary transition-colors italic"
                  dangerouslySetInnerHTML={{ __html: rel.title.rendered }}
                />
              </div>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
};

export default ArticleDetail;
